<template>
  <section class="achievements">
    <div class="content">
      <div class="item left">
        <div class="title">Только свои продукты под iOS & Android</div>
        <div class="scene">
          <img
            src="../assets/images/achievents-background.png"
            class="achievemnts-background"
            alt=""
          />
          <img src="../assets/images/phone.png" class="main-image" alt="" />
          <img
            src="../assets/images/graduation-cap-icon.svg"
            class="graduation-cap"
            alt=""
          />
          <img
            src="../assets/images/movie-clapper-icon.svg"
            class="movie-clapper"
            alt=""
          />
          <img
            src="../assets/images/chart-icon.svg"
            class="chart-icon"
            alt=""
          />
          <img
            src="../assets/images/paint-brushes-icon.svg"
            class="paint-brushes"
            alt=""
          />
        </div>
      </div>
      <div class="item right">
        <img src="../assets/images/about.avif" alt="" />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "AchievementsSection",
};
</script>

<style scoped lang="sass">
@import "../styles/variables.sass"
@import "../styles/mixins.sass"

// Figma scene frame (1920): 862×688 — все % от .scene, картинки масштабируются вместе
.achievements
  width: 100%
  background: #FFFFFF

  .content
    width: 100%
    display: flex
    flex-direction: column
    gap: 16px
    overflow: hidden

    @media screen and (min-width: $tablet)
      gap: 24px

    // Figma 1200 / 1440 / 1920 — две колонки
    @media screen and (min-width: $desktop_xs)
      flex-direction: row
      gap: 0

    .item
      width: 100%
      position: relative
      min-width: 0

      @media screen and (min-width: $desktop_xs)
        width: 50%

      &.left
        display: flex
        flex-direction: column
        align-items: center
        background: #F8F7FF
        padding: 24px 0 0
        box-sizing: border-box

        @media screen and (min-width: $tablet)
          padding-top: 32px

        @media screen and (min-width: $desktop_xs)
          padding-top: 48px
          justify-content: flex-start

        .title
          font-size: 26px
          line-height: 1.3
          font-weight: 590
          text-align: center
          color: #736DCA
          max-width: 343px
          padding: 0 16px
          margin: 0 0 16px
          position: relative
          z-index: 6
          box-sizing: border-box

          @media screen and (min-width: $tablet)
            font-size: 40px
            max-width: 520px
            margin-bottom: 24px

          @media screen and (min-width: $desktop_xs)
            font-size: 44px
            line-height: 1.3
            max-width: 100%
            padding: 0 24px

          @media screen and (min-width: $desktop_small)
            font-size: 50px
            line-height: 65px
            max-width: 618px
            padding: 0

          // ≥1920: оставляем в потоке — absolute наезжал на телефон
          @media screen and (min-width: $desktop)
            font-size: 50px
            line-height: 65px
            max-width: 618px
            margin-bottom: 24px
            position: relative
            top: auto
            left: auto
            transform: none

        .scene
          position: relative
          width: 100%
          max-width: 862px
          margin: 0 auto
          flex-shrink: 0

        .achievemnts-background
          position: absolute
          left: 0
          bottom: 0
          z-index: 2
          width: 75%
          max-width: 75%
          height: auto
          max-height: 90%
          object-fit: contain
          object-position: left bottom

        .main-image
          position: relative
          z-index: 4
          display: block
          width: 72%
          max-width: 616px
          height: auto
          margin: 0 auto
          object-fit: contain

        .graduation-cap,
        .movie-clapper,
        .chart-icon,
        .paint-brushes
          position: absolute
          width: 24%
          max-width: 180px
          height: auto
          object-fit: contain
          pointer-events: none

        .graduation-cap
          top: 8%
          left: 1%
          z-index: 3
          transform: rotate(-13.22deg)
          @include levitateAnimation(-13.22deg)

        .movie-clapper
          top: 18%
          right: 4%
          left: auto
          z-index: 5
          transform: rotate(-9.18deg)
          @include levitateAnimation(-9.18deg)

        .chart-icon
          top: 48%
          left: 0
          z-index: 5
          transform: rotate(5.1deg)
          @include levitateAnimation(5.1deg)

        .paint-brushes
          bottom: 8%
          right: 2%
          left: auto
          top: auto
          z-index: 3
          transform: rotate(18.42deg)
          @include levitateAnimation(18.42deg)

      &.right
        background: #F8F7FF
        display: flex
        align-items: center
        justify-content: center
        overflow: hidden

        img
          width: 100%
          height: auto
          max-height: none
          object-fit: cover
          display: block

          @media screen and (min-width: $desktop_xs)
            height: 100%
            max-height: 660px
            object-fit: cover
</style>
